/**
 * DataElementsApi
 * DataElementsApi
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DataFieldDto { 
    system?: string;
    tableName?: string;
    fieldName?: string;
    title?: string;
    description?: string;
    no?: number;
    dataElement?: string;
    checkTable?: string;
    notNull?: boolean;
    anonymisation?: boolean;
    sourceField?: string;
    sourceCategory?: string;
    source?: string;
    fieldDefinition?: object;
    dtype?: string;
    ftype?: number;
    dimension?: string;
}


export const DataFieldDtoProps = {
  system: 'system',
  tableName: 'tableName',
  fieldName: 'fieldName',
  title: 'title',
  description: 'description',
  no: 'no',
  dataElement: 'dataElement',
  checkTable: 'checkTable',
  notNull: 'notNull',
  anonymisation: 'anonymisation',
  sourceField: 'sourceField',
  sourceCategory: 'sourceCategory',
  source: 'source',
  fieldDefinition: 'fieldDefinition',
  dtype: 'dtype',
  ftype: 'ftype',
  dimension: 'dimension',
} as const;

